import { Vue, Component, Prop } from "vue-property-decorator";
import { ReportsModule } from "@/modules/reports-objective";
import { ReportsLocale } from "@/locales/localeid";
import { fmtMsg } from "commonui";

@Component({
	components: {}
})
export default class ColumnTitle extends Vue {
	private range = 5;
	@Prop({ default: 1 }) startUnit!: number;
	@Prop({ default: 1 }) endUnit!: number;

	get vcsUnits() {
		return ReportsModule.vcsUnits;
	}

	get unitRange() {
		return this.endUnit - this.startUnit + 1;
	}

	get units() {
		const units: number[] = [];
		for (var i = 0; i < this.unitRange; i++) {
			units.push(i + this.startUnit);
		}
		return units;
	}

	get titleSection() {
		return fmtMsg(ReportsLocale.ReportsScopeSequenceTitle);
	}

	getStartUnitWithYear(n) {
		return this.range * (n - 1) + 1;
	}

	getEndUnitWithYear(n) {
		return this.range * n;
	}

	getYearWithUnit(unit) {
		return Math.ceil(unit / this.range);
	}

	get getYearsWithUnits() {
		const years: number[] = [];
		this.units.forEach((uint) => {
			const year = this.getYearWithUnit(uint);
			years.push(year);
		});
		return [...new Set(years)];
	}
}
